(function ($, _) {

	// *************************************************************************
	// Default options
	// *************************************************************************

	var defaultOptions = {
		successMessage: "Record has been successfully saved.",
		hideTimeout: false,
		enableLogging: false,
		success: null
	};


	// *************************************************************************
	// Ajax form class
	// *************************************************************************

	function AjaxForm(form, options) {
		// Basic configuration
		this.$form = $(form);
		this.options = options;

		// Override options with data attributes if defined
		var overrideOptions = {
			successMessage: this.$form.attr("data-success-message"),
			hideTimeout: (this.$form.attr("data-af-hide-timeout") ? parseInt(this.$form.attr("data-af-hide-timeout")) : undefined),
			enableLogging: (this.$form.attr("data-af-log-callback") ? (this.$form.attr("data-af-log-callback") == "true") : undefined),
		};
		for (var key in this.options) {
			if (typeof overrideOptions[key] !== 'undefined') {
				this.options[key] = overrideOptions[key];
			}
		}

		// Advanced configuration
		this.$submitButton = this.$form.find("[type='submit']");

		// Attributes
		this.url = this.$form.attr("action");
		this.id = this.$form.attr("id");
	}
	AjaxForm.prototype = {
		constructor: AjaxForm,

	// Public methods:

		//
		// Submitting form
		//
		submit: function() {
			this.log("Request to: " + this.url);
			this.disableForm();

			var self = this;
			var onSuccess = function(data) {
				self.log(data);
				self.enableForm();
				self.ajaxRequestSuccess(data);
			}
			var onError = function(data) {
				self.log(data);
				self.enableForm();
				self.ajaxRequestError(data);
			}

			// Request
			if (this.$form.attr("enctype") == "multipart/form-data") {
				$.ajax({
					url: this.url,
					dataType: "json",
					type: "POST",
					data: new FormData(this.$form.get(0)),
					cache: false,
					contentType: false,
					processData: false,
					success: onSuccess,
					error: onError,
				});
			}
			else {
				$.ajax({
					url: this.url,
					dataType: "json",
					type: "POST",
					data: this.$form.serialize(),
					success: onSuccess,
					error: onError,
				});
			}
		},

		//
		// Form is valid
		//
		success: function(id) {
			var self = this;
			var animationSpeed = 500;

			this.trigger("ajaxForm.success", { form: this.$form, id: id });
			this.$form.fadeOut(animationSpeed, function() {
				if (self.options.success) {
					self.options.success();
				}

				self.clearForm();

				var $alert = $("<p class='alert alert-success'></p>").insertBefore(self.$form);
				$alert.hide();
				$alert.html(self.options.successMessage);

				$alert.fadeIn(animationSpeed, function() {
					if (self.options.hideTimeout) {
						setTimeout(function() {
							$alert.fadeOut(animationSpeed, function() { $alert.remove(); self.$form.fadeIn(animationSpeed); });
						}, self.options.hideTimeout * 1000)
					}
				});
			});
		},

		//
		// There were errors, form is not valid
		//
		error: function(errors) {
			// this.setFlashMessage(false);
			this.trigger("ajaxForm.error", { form: this.$form, errors: errors });

			// Set error messages
			for (var field in errors) {
				var $field = this.$form.find("[data-af-field='" + field + "']");

				// Fill form with error messages
				var errorMessages = errors[field];
				for (var i = 0; i < errorMessages.length; ++i) {
					$field.append("<div class=\"invalid-feedback\">" + errorMessages[i] + "</div>");
				}

				// Mark field as errorous
				$field.find("[id][name]").addClass("is-invalid");
			}
		},

		//
		// There were communication error
		//
		serverError: function(error) {
			this.trigger("ajaxFrom.serverError", { form: this.$form, error: error });

			var $alert = $("<p class='alert alert-danger'></p>").insertBefore(this.$form);
			$alert.html(error);
		},

		//
		// Build form elements
		//
		build: function() {
			var self = this;

			// Detect, if given form is Rails Bootstrap form
			this.$form.find(".form-group").each(function() {
				var $formGroup = $(this);
				var fieldName = $formGroup.find("[id][name]").attr("name");
				var fieldNames = fieldName ? fieldName.match(/\[([a-zA-Z-_0-9]+)(\([a-zA-Z-_0-9]+\))?\]/) : null;
				var fieldId = fieldNames ? fieldNames[1] : null;
				if (fieldId) {
					$formGroup.attr("data-af-field", fieldId);
				}
			});

			// // Append error messages placeholders
			// this.$form.find("[data-af-field]").each(function() {
			// 	var $field = $(this);
			// 	var fieldId = $field.data("afField");
			// 	var prependErrors = ($field.data("afPrependErrors") ? ($field.data("afPrependErrors") === true) : false);
			// 	// var errorFieldId = self.id + "_" + fieldId + "_errors";
			// 	// var errorFieldHtml = "<span class=\"errors\" id=\"" + errorFieldId + "\"></span>";

			// 	// $field.attr("data-af-id", errorFieldId)

			// 	// if (prependErrors) {
			// 	// 	$field.prepend(errorFieldHtml);
			// 	// } else {
			// 	// 	$field.append(errorFieldHtml);
			// 	// }
			// });
		},

		//
		// Activate AJAX on form
		//
		activate: function() {
			// Submit form via AJAX after click on submit button
			var self = this;
			this.$submitButton.click(function(e) {
				e.preventDefault();

				if (self.isFormEnabled()) {
					self.submit();
				} else {
					self.log("Form is disabled.")
				}
			});
		},


	// Ajax callback methods:

		ajaxRequestSuccess: function(callback) {
			this.success(callback);
		},

		ajaxRequestError: function(callback) {
			if (callback.status == 400 && callback.responseJSON) {
				this.error(callback.responseJSON);
			}
			else {
				var errorMessage = (callback.responseText ? callback.responseText : callback.statusText);
				this.serverError("Error " + callback.status + ": " + errorMessage);
			}
		},

	// Protected methods:

		// Trigger event
		trigger: function(eventName, params) {
			this.$form.trigger(eventName, params);
		},

		// Log message
		log: function(message) {
			if (this.options.enableLogging) {
				console.log(message);
			}
		},

		disableForm: function() {
			this.$form.addClass("af-sending-request");
		},

		enableForm: function() {
			this.$form.removeClass("af-sending-request");
			this.clearErrors();
			if (this.clearCallback) {
				this.clearCallback();
			}
		},

		isFormEnabled: function() {
			return !this.$form.hasClass("af-sending-request");
		},

		clearErrors: function() {
			this.$form.find(".invalid-feedback").remove();
			this.$form.find(".is-invalid").removeClass("is-invalid");
			this.$form.prev(".alert").remove();
		},

		clearForm: function() {
			this.clearErrors();

			if (this.options.clearOnSubmit) {
				this.$form.find(".form-control").val("");
			}
		},

	};



	// *************************************************************************
	// jQuery plugin
	// *************************************************************************

	$.fn.ajaxForm = function(options) {
		$(this).each(function() {
			var opts = $.extend({}, $.ajaxForm.defaults, options);
			var ajaxForm = new AjaxForm(this, opts);
			ajaxForm.build();
			ajaxForm.activate();
		});
	}

	$.ajaxForm = function(options) {
		$("[data-af]").ajaxForm(options);
	}

	$.ajaxForm.defaults = defaultOptions;


	// *************************************************************************
	// Publish to public interface
	// *************************************************************************

	if (!_.story) { _.story = {}; }

	_.story.AjaxForm = AjaxForm;

}(jQuery, window));
